import { defineProp } from './functionalUtils';

declare global {
  interface Number {
    formatted(this: number): string;
    formattedAsAcronyms(this: number): string;
    clamp(this: number, min: number, max: number): number;
  }
}

const _clamp = function (this: number, min: number, max: number): number {
  return Math.min(Math.max(this, min), max);
};

const _formatted = function (this: number): string {
  return this.toLocaleString('en-US');
};

const _formattedAsAcronyms = function (this: number): string {
  const digits = this.toString().length;
  return digits <= 3
    ? this.toString()
    : digits <= 6
      ? `${Math.floor(this / 1_000)}K`
      : `${Math.floor(this / 1_000_000)}M`;
};

if (!Number.prototype.formatted) {
  defineProp(Number.prototype, 'formatted', _formatted);
  defineProp(Number.prototype, 'formattedAsAcronyms', _formattedAsAcronyms);
  defineProp(Number.prototype, 'clamp', _clamp);
}

export const convertNumberToAcronyms = (numeral: number) => numeral.formattedAsAcronyms();
